import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { toast } from "react-toastify";

import styles from "../custom.module.css";

import userCard from "../../assets/img/user/card/green/01.png";
import userCard2 from "../../assets/img/user/card/green/02.png";
import { 
  getTRONAddress, 
  getBEP20Address, 
  withdrawRewards, 
  getWalletData 
} from "../../redux/actions/wallet";
import WalletReportTable from "./WalletReportTable";

const WalletFunctions = () => {
  const dispatch = useDispatch();
  
  // Select data from Redux store
  const { addressData, walletData, withdrawableBal } = useSelector((state) => ({
    addressData: state.wallet.addressData,
    walletData: state.wallet.walletData,
    withdrawableBal: state.wallet?.walletData?.withBal,
  }));



  console.log("🔍 Frontend - walletData:", walletData);

  const [formData, setFormData] = useState({ address: "", amount: 0 });
  const [otp, setOtp] = useState("");
  const [isMail, setIsMail] = useState(true);
  const [isRequest, setIsRequest] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [countdown, setCountdown] = useState(0);
  
  const { address, amount } = formData;

  useEffect(() => {
    console.log("🔄 WalletFunctions - useEffect: Fetching wallet data");
    dispatch(getWalletData());
  }, [dispatch]);

  const onChange = (e) => {
    const { name, value } = e.target;
    console.log(`📝 Form field changed: ${name} = ${value}`);
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleGenerateWallet = () => {
    console.log("🎯 WalletFunctions - Generating BEP20 address");
    dispatch(getBEP20Address());
  };

  const handleWithdrawal = async (e) => {
    e.preventDefault();
    console.log("💰 WalletFunctions - Withdrawal requested", { address, amount, isMail });
    
    setIsRequest(true);

    const withdrawalData = { 
      address: address.trim(), 
      isMail, 
      otp: otp.trim(), 
      amount: parseFloat(amount) 
    };

    console.log("📤 Withdrawal data prepared:", withdrawalData);

    try {
      dispatch(withdrawRewards(withdrawalData, (success) => {
        console.log("✅ Withdrawal callback received:", success);
        
        if (success === "OTP_SENT") {
          console.log("📧 OTP sent to email");
          setIsMail(false);
          toast.success("OTP sent to your email!");
        } else if (success === "SUCCESS") {
          console.log("✅ Withdrawal successful");
          setIsMail(true);
          setFormData({ address: "", amount: 0 });
          setOtp("");
          toast.success("Withdrawal request submitted successfully!");
          
          // Refresh wallet data
          dispatch(getWalletData());
        } else {
          console.warn("⚠️ Unknown success status:", success);
        }
        
        setIsRequest(false);
      }));
    } catch (error) {
      console.error("❌ Withdrawal error:", error);
      toast.error("Withdrawal failed. Please try again.");
      setIsRequest(false);
    }
  };

  // Countdown timer effect
  useEffect(() => {
    console.log("⏰ Countdown effect triggered", { isDisabled, countdown });
    
    let timer;
    if (isDisabled && countdown > 0) {
      timer = setInterval(() => {
        setCountdown((prev) => {
          const newCount = prev - 1;
          console.log(`⏰ Countdown: ${newCount}`);
          return newCount;
        });
      }, 1000);
    } else if (countdown === 0 && isDisabled) {
      console.log("✅ Countdown finished, enabling button");
      setIsDisabled(false);
      clearInterval(timer);
    }
    
    return () => {
      if (timer) {
        console.log("🧹 Cleaning up countdown timer");
        clearInterval(timer);
      }
    };
  }, [isDisabled, countdown]);

  const handleCopy = () => {
    if (addressData?.address) {
      navigator.clipboard.writeText(addressData.address)
        .then(() => {
          console.log("📋 Address copied to clipboard:", addressData.address);
          toast.success("Address copied to clipboard!");
        })
        .catch(err => {
          console.error("❌ Copy failed:", err);
          toast.error("Failed to copy address!");
        });
    } else {
      console.warn("⚠️ No address available to copy");
      toast.error("No address to copy!");
    }
  };

  const handleStartCountdown = (seconds = 60) => {
    console.log(`⏰ Starting countdown: ${seconds} seconds`);
    setIsDisabled(true);
    setCountdown(seconds);
  };

  console.log("🎨 WalletFunctions - Rendering UI", {
    isMail,
    isRequest,
    isDisabled,
    countdown,
    formData
  });

  return (
    <div>
      <section className="user-ditails-wrapper fix section-bg-5 section-padding-medium">
        <div className="container">
          <div className="row mb-4">
            {/* Deposit Card */}
            <div className="col-xl-6 col-sm-12">
              <div
                className="single-user-ditails-card single-user-ditails-card--style2 mb-4 mb-xl-0 wow fadeInUp"
                data-wow-duration="1s"
                data-wow-delay=".2s"
              >
                <div className="user-card-wrapper">
                  <div className="user-card-thumb">
                    <img src={userCard} alt="invest icon" />
                  </div>
                  <div className="user-card-content mt-2">
                    <div className={styles.twoColumns}>
                      <div className="col">
                        <div className={styles.fontMediumBold}>
                          Total Deposit
                        </div>
                        <p>${walletData?.totalCredit?.toFixed(2) || "0.00"}</p>
                      </div>
                      <div className="col mb-2">
                        <p>
                          <button
                            className="btn btn-success my-2"
                            data-bs-toggle="collapse"
                            href="#collapseDeposit"
                            onClick={handleGenerateWallet}
                            role="button"
                            aria-expanded="false"
                            aria-controls="collapseDeposit"
                            disabled={isDisabled}
                          >
                            {isDisabled ? `Wait ${countdown}s` : "Deposit"}
                          </button>
                        </p>
                        <div className="fs-small my-3">
                          Get the deposit address for BEP20 USDT deposit via the blockchain.
                        </div>
                      </div>
                    </div>
                    <div className="collapse" id="collapseDeposit">
                      <div className="card card-body d-flex flex-column align-items-center p-4 justify-content-center">
                        {addressData?.qrCode && (
                          <img
                            className="mb-3"
                            src={addressData.qrCode}
                            alt="QR Code"
                            height="150"
                            width="150"
                            onError={(e) => {
                              console.error("❌ QR Code failed to load");
                              e.target.style.display = 'none';
                            }}
                          />
                        )}
                        <div className="input-group pb-3">
                          <input
                            type="text"
                            value={addressData?.address || "Generating address..."}
                            className="form-control text-center"
                            readOnly
                          />
                          <span
                            className="input-group-text"
                            onClick={handleCopy}
                            style={{ cursor: addressData?.address ? "pointer" : "not-allowed" }}
                            title="Copy address"
                          >
                            <i className="fa fa-copy"></i>
                          </span>
                        </div>
                        <div
                          className="alert alert-warning alert-dismissible p-3 mt-3"
                          role="alert"
                        >
                          * Please double check copied address while deposit to avoid any transaction delay.
                          <br />
                          <br />* Deposit Transaction is processed after a minimum of 10 confirmations.
                          <button
                            type="button"
                            className="btn-close text-danger"
                            data-bs-dismiss="alert"
                            aria-label="Close"
                          ></button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Withdrawal Card */}
            <div className="col-xl-6 col-sm-12">
              <div
                className="single-user-ditails-card single-user-ditails-card--style2 mb-4 mb-xl-0 wow fadeInUp"
                data-wow-duration="1s"
                data-wow-delay=".2s"
              >
                <div className="user-card-wrapper">
                  <div className="user-card-thumb">
                    <img src={userCard2} alt="invest icon" />
                  </div>
                  <div className="user-card-content mt-2">
                    <div className={styles.twoColumns}>
                      <div className="col">
                        <div className={styles.fontMediumBold}>
                          Withdrawal Balance
                        </div>
                        <p>${Number(walletData?.withAmount).toFixed(4) || "0.00"}</p>
                      </div>
                      <div className="col mb-2">
                        <p>
                          <button
                            className="btn btn-danger"
                            data-bs-toggle="collapse"
                            href="#collapseWithdraw"
                            role="button"
                            aria-expanded="false"
                            aria-controls="collapseWithdraw"
                          >
                            Withdraw
                          </button>
                        </p>
                        <div className="fs-small my-3">
                          Submit your correct BEP20 USDT address for withdrawal.
                        </div>
                      </div>
                    </div>
                    <div className="collapse" id="collapseWithdraw">
                      <div className="card card-body p-3">
                        <div className="form_container text-center">
                          <form onSubmit={handleWithdrawal}>
                            {isMail ? (
                              <div>
                                <input
                                  type="text"
                                  name="address"
                                  value={address}
                                  onChange={onChange}
                                  className="form-control mb-3"
                                  placeholder="Your USDT Wallet Address"
                                  required
                                  disabled={isRequest}
                                />
                                <input
                                  type="number"
                                  className="form-control"
                                  name="amount"
                                  value={amount}
                                  onChange={onChange}
                                  placeholder="Enter Amount"
                                  min="0"
                                  step="0.01"
                                  required
                                  disabled={isRequest}
                                />
                                <div className="btn_box mt-3 pb-3 text-center">
                                  <button
                                    type="submit"
                                    className="btn btn-medium btn-danger"
                                    disabled={isRequest || !address.trim() || !amount || amount <= 0}
                                  >
                                    {isRequest ? "Processing..." : "Submit Withdrawal"}
                                  </button>
                                </div>
                              </div>
                            ) : (
                              <>
                                <div>
                                  <input
                                    type="text"
                                    className="form-control"
                                    name="otp"
                                    value={otp}
                                    onChange={(e) => setOtp(e.target.value)}
                                    placeholder="Enter OTP"
                                    required
                                    disabled={isRequest}
                                  />
                                </div>
                                <div className="btn_box mt-3 pb-3 text-center">
                                  <button
                                    type="submit"
                                    className="btn btn-medium btn-danger"
                                    disabled={isRequest || !otp.trim()}
                                  >
                                    {isRequest ? "Verifying..." : "Submit OTP"}
                                  </button>
                                </div>
                              </>
                            )}
                            
                            <div
                              className="alert alert-warning alert-dismissible mt-3"
                              role="alert"
                            >
                              * All withdrawal requests are processed within a few minutes.
                              <button
                                type="button"
                                className="btn-close text-danger"
                                data-bs-dismiss="alert"
                                aria-label="Close"
                              ></button>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          {/* Wallet Report Table */}
          <div className="row">
            <WalletReportTable walletData={walletData} />
          </div>
        </div>
      </section>
    </div>
  );
};

export default WalletFunctions;